import React, { useState, useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { Routes, Route, BrowserRouter, Outlet } from 'react-router-dom';
import PharmacyReports from 'pages/PharmacyReports';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import './style/pfapp.scss';

import Login from 'pages/Login';
import NotValidTab from 'pages/NotValidTab';
import { PrivateRoute } from 'routes/privateRoute';

const App = () => {
  const [modules, setModules] = useState([])
  const [orgId, setOrgId] = useState(window.selectedOrganizationId);
  const onOrgChange = (orgId) => {
    setOrgId(orgId)
  }


  const renderLogin = () => {
    return (<Route index element={<Login />} />)
  }

  const renderPharmacyReports = () => {   
      return (<Route path='/pharmacyreports' element={<PharmacyReports module={module[0]} orgId={orgId} />} />)
  }

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route element={<Outlet />}>
            <Route element={<PrivateRoute modules={modules} onAppOrgChange={onOrgChange}/>}>
              {renderLogin()}
              {renderPharmacyReports()}
            </Route>
            {/* catch all */}
            <Route path='*' element={<NotValidTab />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer position='top-right' autoClose={3000} />
    </>
  );
};

export default App;
